import { httpRequest } from '@calendly/http-tools'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const updatePaymentInfo = createAsyncThunk(
  'billing/updatePaymentInfo',
  async ({ stripe, elements, billingCountry, billingZip }, { rejectWithValue }) => {
    const submitResult = await elements.submit()
    if (submitResult.error) {
      return rejectWithValue(submitResult.error)
    }
    const [piSuccess, piResponse] = await httpRequest({
      url: '/api/billing/subscription/payment_info',
      method: 'GET'
    })
    if (!piSuccess) {
      return rejectWithValue(piResponse)
    }
    const paymentIntent = await stripe.confirmSetup({
      elements,
      clientSecret: piResponse.client_secret,
      redirect: 'if_required',
      confirmParams: {
        return_url: window.location.href,
        payment_method_data: {
          billing_details: {
            name: '',
            email: '',
            phone: '',
            address: {
              country: billingCountry,
              state: '',
              city: '',
              line1: '',
              line2: '',
              postal_code: billingZip
            }
          },
        },
      }
    })

    const paymentMethodId = paymentIntent?.setupIntent?.payment_method
    if (!paymentMethodId) {
      return rejectWithValue('Payment method not found')
    }
    try {
      const [setDefaultSuccess, setDefaultResponse] = await httpRequest({
        url: '/api/billing/subscription/payment_info',
        method: 'POST',
        data: {
          payment_info: {
            payment_method_id: paymentMethodId
          }
        }
      })
      if (!setDefaultSuccess) {
        return rejectWithValue(setDefaultResponse)
      }
    } catch (error) {
      return rejectWithValue(error)
    }
    return true
  }
)
